import { useTranslation } from "react-i18next";

const PurchaseSummary = (props: {
    icon: string;
    name: string;
    amount: number;
}) => {
    const { t } = useTranslation();

    return (
        <div className="confirm__information">
            <div className="flex flex-jc-sb">
                <p className="confirm__title">App</p>
                <p className="confirm__title ta-r">{t("confirm.voucherAmount")}</p>
            </div>

            <div className="flex flex-jc-sb">
                <div className="flex flex-ai-c">
                    <img
                        alt={props.name}
                        src={props.icon}
                        className="confirm__icon"
                    />
                    <p className="confirm__name">{props.name}</p>
                </div>
                <p className="confirm__amount ta-r">{props.amount},00 €</p>
            </div>
        </div>
    );
};

export default PurchaseSummary;
